module.exports = __webpack_public_path__ + "img/login-aubert.67154d16.png";